<template>
  <div class="cant-find-page" @scroll="scrolling()">
    <section class="cf__banner">
      <picture class="cf__banner-img">
        <source
          media="(max-width: 768px)"
          srcset="
            @/assets/cant-find/bg-cant-find_small.webp    1x,
            @/assets/cant-find/bg-cant-find_small@2x.webp 2x
          "
        />
        <source
          media="(max-width: 768px)"
          srcset="
            @/assets/cant-find/bg-cant-find_small.jpg    1x,
            @/assets/cant-find/bg-cant-find_small@2x.jpg 2x
          "
        />

        <source
          media="(min-width: 768px) and (max-width: 1199px)"
          srcset="
            @/assets/cant-find/bg-cant-find_medium.webp    1x,
            @/assets/cant-find/bg-cant-find_medium@2x.webp 2x
          "
        />
        <source
          media="(min-width: 768px) and (max-width: 1199px)"
          srcset="
            @/assets/cant-find/bg-cant-find_medium.jpg    1x,
            @/assets/cant-find/bg-cant-find_medium@2x.jpg 2x
          "
        />

        <source
          srcset="
            @/assets/cant-find/bg-cant-find.webp    1x,
            @/assets/cant-find/bg-cant-find@2x.webp 2x
          "
        />
        <source
          srcset="
            @/assets/cant-find/bg-cant-find.jpg    1x,
            @/assets/cant-find/bg-cant-find@2x.jpg 2x
          "
        />

        <img
          src="@/assets/cant-find/bg-cant-find.jpg"
          alt="Can’t find a suitable vendor for your project"
          loading="lazy"
          width="1920"
          height="640"
        />
      </picture>
      <h1 class="cf__banner-title">
        Wordpress Websites Maintenance
      </h1>
    </section>
      <section-layout name="cf__hosting" title="Hosting" margin="true">
        <p>
          Free hosting on WPEngine for any Wordpress site (up to 1GB storage and 10GB bandwidth, larger sites need to be discussed)
        </p>
      </section-layout>
      <section-layout name="cf__backups" title="Backups + Updates" margin="true">
        <ul>
          <li>Monthly Personal Site Check including WordPress Core + Plugin Updates</li>
          <li>Daily Security-related WordPress Updates</li>
          <li>Daily Backups: Database, Theme, Plugins, Media Uploads</li>
        </ul>
      </section-layout>
      <section-layout name="cf__support" title="Support" margin="true">
        <ul>
          <li>
            Up to 1hr/mo Website Repairs or Content Edits
          </li>
        </ul>
      </section-layout>
      <section-layout name="cf__cost" title="Cost" margin="true">
        <ul>
          <li>
            $200/month
          </li>
        </ul>
      </section-layout>
      <section-layout name="cf__include" title="What the Wordpress Maintenance Plan does not include:" margin="true">
        <ul>
          <li>Additional Site Modification hours requiring design or development expertise</li>
          <li>Fixes to plugins </li>
          <li>Development of new features or functions to the website including elements that need to be designed, coded or templated</li>
          <li>Support for managing third-party integrations and APIs (Includes but is not limited to: Salesforce, HubSpot, Greenhouse, Mailchimp)</li>
          <li>Configuration of existing plugins on your website</li>
          <li>Migration of files to a separate server in the event that your website files are over 1GB in size</li>
          <li>Hosting for any site with over 50,000 visits per month, 1GB storage, or 10GB bandwidth </li>
        </ul>
        <p>*All of these requests are billable at our current hourly rate and are not included in our maintenance program. Our team would be happy to support you with any of your needs: <a href="/contacts">Contact Us</a>.</p>
        <p>
          <em v-html="text"></em>
        </p>
        <ContactsButton size="large" :desc="text" :id="btnModalId" />
      </section-layout>
  </div>
</template>

<script>
import SectionLayout from "@/layouts/SectionLayout";
import ContactsButton from "@/components/ContactsButton.vue";

export default {
  data() {
    return {
      scroll: false,
      position: null,
      text: `
      Would you like to receive more examples of what we are able to help you achieve?<br />
      Do you still have doubts about your idea and believe that it will be too hard to implement?<br/>
      Would you like us to propose ways of turning your ideas into reality?
      `,
      btnModalId: 'cant-find-section-modal',
    };
  },
  components: {
    SectionLayout,
    ContactsButton,
  },
  methods: {
    back(){
      if(!document.referrer){
        Object.defineProperty(document,"referrer",{get : function(){ return `${window.location.origin}/blog` }})
        this.$router.push('/blog')
      }else{
        this.$router.go(-2)
      }
    },
    scrolling() {
      const scroll = document.documentElement.scrollTop;
      if (scroll > 50) {
        this.scroll = true;
      } else {
        this.scroll = false;
      }
    },
  },
  created() {
    history.pushState('cant-find',window.location.href)
    window.history.scrollRestoration = "auto";
    window.addEventListener("scroll", this.scrolling);
  },
  beforeUnmount() {
    window.removeEventListener("scroll", this.scrolling);
  },
};
</script>

<style lang="scss">
@import "../scss/_variables.scss";
@import "include-media/dist/_include-media.scss";

.footer-blog-item{
  display:block;
  padding-top:20px;
  @include media(">=tablet") {
    display:flex;
    justify-content: space-between;
    align-items: center;
  }
  .cant-find-tags{
    margin-top:40px;
    color:$red;
    font-weight: 700;
    font-size: 16px;
    line-height: 28px;
    @include media(">=tablet") {
      margin-top:0px;
      text-align: center;
    }
    span{
      margin-right: 20px;
      @include media(">=widescreen") {
        margin-right: 40px;
      }
    }
  }
}


.cant-find-page {
  .btn-read-more{
  .button-content {
    border-radius: 26px;
    padding: 2px 12px 3px;
    background: $red;
    color: $white;
    font-weight: 700;
    font-size: 16px;
    line-height: 28px;
    cursor: pointer;
    width: max-content;
    background-image: linear-gradient($darkRed, $darkRed);
    background-repeat: no-repeat;
    transition: background-size 0s, color 0s;
    background-size: 0% 100%;
    @include media(">=tablet-xl") {
      padding: 6px 24px 8px;
    }
    &:hover {
      background-size: 100% 100%;
      color: $white;
    }
  }
  .icon {
    padding-top: 6px;
    margin-right: 15px;
    transform: rotateY(180deg);
  }
  a {
    color: $white;
    text-decoration: none;
    &:hover {
      text-decoration: underline;
    }
  }
  }

  .go-back-to-read {
    padding: 16px 10px;
    border-bottom-left-radius: 26px 26px;
    border-bottom-right-radius: 26px 26px;
    position: fixed;
    background: $white;
    z-index: 50;
    width: 100vw;
    transition: all 0.3s;
    @include media(">=tablet-xl") {
      padding: 16px 80px;
    }
    &.scrolling {
      padding: 5px 10px;
      border-bottom: 1px solid $red;
       @include media(">=tablet-xl") {
         padding: 5px 80px;
       }

    }
  }
}
.blog-cant-find {
  &.section_holder {
    display: flex;
    flex-direction: column-reverse;
    @include media(">=tablet-xl") {
      flex-direction: row;
    }
  }
  .section_title {
    margin-right: 0px;
    width: 100%;
    @include media(">=tablet-xl") {
      margin-right: 43px;
      width: 35%;
    }
  }
  .section_content {
    margin-bottom: 60px;
    display: block;
    margin-left: 0px;
    width: 100%;
    a {
      color: $red;
    }
    &__item{
      margin-bottom:40px;
      @include media(">=tablet") {
        margin-bottom:60px;
      }
      @include media(">=desktop") {
        margin-bottom:120px;
      }
    }
    @include media(">=tablet-xl") {
      margin-left: 37px;
      width: 65%;
      margin-bottom: 0px;
    }
  }
}

.cf__banner {
  height: 300px;
  position: relative;
  @include media(">=tablet") {
    height: 500px;
  }
  @include media(">=desktop") {
    height: 640px;
    margin-bottom: 60px;
  }
  &-img {
    display: block;
    height: 100%;
    img {
      display: block;
      width: 100%;
      height: 100%;
      object-fit: cover;
    }
  }
}
.cf__banner-title {
  text-transform: uppercase;
  color: $white;
  font-size: 32px;
  line-height: 111%;
  position: absolute;
  bottom: 20px;
  left: 16px;
  max-width: calc(100% - 32px);
  margin: 0;
  @include media(">=tablet") {
    bottom: 40px;
    font-size: 40px;
    left: 40px;
    max-width: calc(100% - 80px);
  }
  @include media(">=tablet-xl") {
    bottom: 80px;
    left: 40px;
    font-size: 56px;
    max-width: calc(100% - 80px);
  }
  @include media(">=widescreen") {
    bottom: 80px;
    left: 80px;
    font-size: 64px;
    max-width: 1150px;
  }
}
.cf__hosting,
.cf__backups,
.cf__support,
.cf__cost,
.cf__include {
  p {
    margin-bottom: 0;
  }
  ul {
    padding-left: 30px;
    margin-bottom: 0px;
    ul {
      margin-top: 32px;
      li {
        margin-bottom: 10px;
        &:last-child {
          margin-bottom: 0;
        }
      }
    }
    li {
      margin-bottom: 32px;
    }
  }

  a {
    color: $red;
    text-decoration: none;
    &:hover {
      text-decoration: underline;
    }
  }
  .section_content {
    flex-direction: column;
    align-items: flex-start;
  }
  .section_title {
    margin-bottom: 30px;
    @include media(">=tablet") {
      margin-bottom: 60px;
    }
  }
}
.cf__img {
  margin: 40px 0;
  display: block;
}
.cf__include {
  em {
    display: block;
    margin-top: 32px;
  }
  .button {
    margin-top: 40px;
  }
}
</style>
